"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPlanForLocation = exports.getLocationSummaryCurrentPlans = exports.getGiftingPlanForLocation = exports.getLocationPlans = exports.getCurrencySymbol = exports.isUSMediumLocation = exports.veryHighFootprint = exports.highFootprint = exports.veryHighImpactCountries = exports.locationConsumptions = exports.plansForLocations = exports.Consumptions = void 0;
const addons_1 = require("./addons");
const tree_projects_1 = require("../tree-projects");
const countries_1 = require("./countries");
const addons = __importStar(require("./addons"));
const plans = __importStar(require("./plans"));
const currencies_1 = require("./currencies");
const country_transform_1 = require("./country-transform");
const plan_country_mappings_1 = require("./plan-country-mappings");
var Consumptions;
(function (Consumptions) {
    Consumptions["HIGH"] = "high";
    Consumptions["VERY_HIGH"] = "very high";
})(Consumptions = exports.Consumptions || (exports.Consumptions = {}));
exports.plansForLocations = {
    AU: plans.individualPlansAU,
    CA: plans.individualPlansCA,
    EU: plans.individualPlansEU,
    GB: plans.individualPlansGB,
    US: plans.individualPlansUS,
    AD: plans.individualPlansUSDMedium,
    AF: plans.individualPlansUSDMedium,
    AG: plans.individualPlansUSDMedium,
    AL: plans.individualPlansUSDMedium,
    AM: plans.individualPlansUSDMedium,
    AO: plans.individualPlansUSDMedium,
    AQ: plans.individualPlansUSDMedium,
    AR: plans.individualPlansUSDMedium,
    AW: plans.individualPlansUSDMedium,
    AZ: plans.individualPlansUSDMedium,
    BA: plans.individualPlansUSDMedium,
    BB: plans.individualPlansUSDMedium,
    BD: plans.individualPlansUSDMedium,
    BF: plans.individualPlansUSDMedium,
    BI: plans.individualPlansUSDMedium,
    BJ: plans.individualPlansUSDMedium,
    BM: plans.individualPlansUSDMedium,
    BO: plans.individualPlansUSDMedium,
    BQ: plans.individualPlansUSDMedium,
    BR: plans.individualPlansUSDMedium,
    BS: plans.individualPlansUSDMedium,
    BT: plans.individualPlansUSDMedium,
    BY: plans.individualPlansUSDMedium,
    CD: plans.individualPlansUSDMedium,
    CI: plans.individualPlansUSDMedium,
    CL: plans.individualPlansUSDMedium,
    CM: plans.individualPlansUSDMedium,
    CN: plans.individualPlansUSDMedium,
    CO: plans.individualPlansUSDMedium,
    CR: plans.individualPlansUSDMedium,
    CU: plans.individualPlansUSDMedium,
    CV: plans.individualPlansUSDMedium,
    CW: plans.individualPlansUSDMedium,
    DO: plans.individualPlansUSDMedium,
    DZ: plans.individualPlansUSDMedium,
    EC: plans.individualPlansUSDMedium,
    EG: plans.individualPlansUSDMedium,
    EH: plans.individualPlansUSDMedium,
    ET: plans.individualPlansUSDMedium,
    FJ: plans.individualPlansUSDMedium,
    FK: plans.individualPlansUSDMedium,
    FM: plans.individualPlansUSDMedium,
    FO: plans.individualPlansUSDMedium,
    GA: plans.individualPlansUSDMedium,
    GD: plans.individualPlansUSDMedium,
    GE: plans.individualPlansUSDMedium,
    GG: plans.individualPlansUSDMedium,
    GH: plans.individualPlansUSDMedium,
    GI: plans.individualPlansUSDMedium,
    GM: plans.individualPlansUSDMedium,
    GP: plans.individualPlansUSDMedium,
    GQ: plans.individualPlansUSDMedium,
    GR: plans.individualPlansUSDMedium,
    GT: plans.individualPlansUSDMedium,
    GU: plans.individualPlansUSDMedium,
    HK: plans.individualPlansUSDMedium,
    HN: plans.individualPlansUSDMedium,
    HR: plans.individualPlansUSDMedium,
    HT: plans.individualPlansUSDMedium,
    ID: plans.individualPlansUSDMedium,
    IL: plans.individualPlansUSDMedium,
    IN: plans.individualPlansUSDMedium,
    IQ: plans.individualPlansUSDMedium,
    IR: plans.individualPlansUSDMedium,
    IS: plans.individualPlansUSDMedium,
    JE: plans.individualPlansUSDMedium,
    JM: plans.individualPlansUSDMedium,
    JO: plans.individualPlansUSDMedium,
    JP: plans.individualPlansUSDMedium,
    KE: plans.individualPlansUSDMedium,
    KG: plans.individualPlansUSDMedium,
    KH: plans.individualPlansUSDMedium,
    KN: plans.individualPlansUSDMedium,
    KR: plans.individualPlansUSDMedium,
    KY: plans.individualPlansUSDMedium,
    LA: plans.individualPlansUSDMedium,
    LB: plans.individualPlansUSDMedium,
    LC: plans.individualPlansUSDMedium,
    LI: plans.individualPlansUSDMedium,
    LK: plans.individualPlansUSDMedium,
    LS: plans.individualPlansUSDMedium,
    LT: plans.individualPlansUSDMedium,
    LV: plans.individualPlansUSDMedium,
    LY: plans.individualPlansUSDMedium,
    MA: plans.individualPlansUSDMedium,
    MC: plans.individualPlansUSDMedium,
    MD: plans.individualPlansUSDMedium,
    ME: plans.individualPlansUSDMedium,
    MG: plans.individualPlansUSDMedium,
    MK: plans.individualPlansUSDMedium,
    ML: plans.individualPlansUSDMedium,
    MM: plans.individualPlansUSDMedium,
    MN: plans.individualPlansUSDMedium,
    MO: plans.individualPlansUSDMedium,
    MQ: plans.individualPlansUSDMedium,
    MR: plans.individualPlansUSDMedium,
    MT: plans.individualPlansUSDMedium,
    MU: plans.individualPlansUSDMedium,
    MV: plans.individualPlansUSDMedium,
    MW: plans.individualPlansUSDMedium,
    MX: plans.individualPlansUSDMedium,
    MY: plans.individualPlansUSDMedium,
    MZ: plans.individualPlansUSDMedium,
    NA: plans.individualPlansUSDMedium,
    NC: plans.individualPlansUSDMedium,
    NE: plans.individualPlansUSDMedium,
    NF: plans.individualPlansUSDMedium,
    NG: plans.individualPlansUSDMedium,
    NI: plans.individualPlansUSDMedium,
    NP: plans.individualPlansUSDMedium,
    NZ: plans.individualPlansUSDMedium,
    PA: plans.individualPlansUSDMedium,
    PE: plans.individualPlansUSDMedium,
    PF: plans.individualPlansUSDMedium,
    PG: plans.individualPlansUSDMedium,
    PH: plans.individualPlansUSDMedium,
    PK: plans.individualPlansUSDMedium,
    PR: plans.individualPlansUSDMedium,
    PS: plans.individualPlansUSDMedium,
    PY: plans.individualPlansUSDMedium,
    RE: plans.individualPlansUSDMedium,
    RS: plans.individualPlansUSDMedium,
    RU: plans.individualPlansUSDMedium,
    RW: plans.individualPlansUSDMedium,
    SC: plans.individualPlansUSDMedium,
    SD: plans.individualPlansUSDMedium,
    SG: plans.individualPlansUSDMedium,
    SI: plans.individualPlansUSDMedium,
    SK: plans.individualPlansUSDMedium,
    SL: plans.individualPlansUSDMedium,
    SM: plans.individualPlansUSDMedium,
    SN: plans.individualPlansUSDMedium,
    SO: plans.individualPlansUSDMedium,
    SS: plans.individualPlansUSDMedium,
    SV: plans.individualPlansUSDMedium,
    SY: plans.individualPlansUSDMedium,
    SZ: plans.individualPlansUSDMedium,
    TD: plans.individualPlansUSDMedium,
    TG: plans.individualPlansUSDMedium,
    TH: plans.individualPlansUSDMedium,
    TJ: plans.individualPlansUSDMedium,
    TL: plans.individualPlansUSDMedium,
    TN: plans.individualPlansUSDMedium,
    TR: plans.individualPlansUSDMedium,
    TV: plans.individualPlansUSDMedium,
    TW: plans.individualPlansUSDMedium,
    TZ: plans.individualPlansUSDMedium,
    UA: plans.individualPlansUSDMedium,
    UG: plans.individualPlansUSDMedium,
    UY: plans.individualPlansUSDMedium,
    UZ: plans.individualPlansUSDMedium,
    VC: plans.individualPlansUSDMedium,
    VE: plans.individualPlansUSDMedium,
    VG: plans.individualPlansUSDMedium,
    VI: plans.individualPlansUSDMedium,
    VN: plans.individualPlansUSDMedium,
    VU: plans.individualPlansUSDMedium,
    XK: plans.individualPlansUSDMedium,
    YE: plans.individualPlansUSDMedium,
    YT: plans.individualPlansUSDMedium,
    ZA: plans.individualPlansUSDMedium,
    ZM: plans.individualPlansUSDMedium,
    ZW: plans.individualPlansUSDMedium,
    AE: plans.individualPlansUS,
    BH: plans.individualPlansUS,
    BN: plans.individualPlansUS,
    BW: plans.individualPlansUS,
    BZ: plans.individualPlansUS,
    EE: plans.individualPlansUS,
    GY: plans.individualPlansUS,
    KW: plans.individualPlansUS,
    KZ: plans.individualPlansUS,
    LU: plans.individualPlansUS,
    OM: plans.individualPlansUS,
    QA: plans.individualPlansUS,
    SA: plans.individualPlansUS,
    SR: plans.individualPlansUS,
    TM: plans.individualPlansUS,
    TT: plans.individualPlansUS,
    AT: plans.individualPlansEU,
    BE: plans.individualPlansEU,
    CY: plans.individualPlansEU,
    DK: plans.individualPlansEU,
    FI: plans.individualPlansEU,
    FR: plans.individualPlansEU,
    DE: plans.individualPlansEU,
    IE: plans.individualPlansEU,
    IT: plans.individualPlansEU,
    NL: plans.individualPlansEU,
    NO: plans.individualPlansEU,
    PL: plans.individualPlansEU,
    ES: plans.individualPlansEU,
    SE: plans.individualPlansEU,
    CH: plans.individualPlansEU,
    CZ: plans.individualPlansEU,
    HU: plans.individualPlansEU,
    PT: plans.individualPlansEU,
    BG: plans.individualPlansEU,
    RO: plans.individualPlansEU, // Romania
};
const familyPlanIdsForLocation = {
    AU: plans.familyPlanIdAU,
    CA: plans.familyPlanIdCA,
    EU: plans.familyPlanIdEU,
    GB: plans.familyPlanIdGB,
    US: plans.familyPlanIdUS,
    AD: plans.familyPlanIdUSMedium,
    AF: plans.familyPlanIdUSMedium,
    AG: plans.familyPlanIdUSMedium,
    AL: plans.familyPlanIdUSMedium,
    AM: plans.familyPlanIdUSMedium,
    AO: plans.familyPlanIdUSMedium,
    AQ: plans.familyPlanIdUSMedium,
    AR: plans.familyPlanIdUSMedium,
    AW: plans.familyPlanIdUSMedium,
    AZ: plans.familyPlanIdUSMedium,
    BA: plans.familyPlanIdUSMedium,
    BB: plans.familyPlanIdUSMedium,
    BD: plans.familyPlanIdUSMedium,
    BF: plans.familyPlanIdUSMedium,
    BI: plans.familyPlanIdUSMedium,
    BJ: plans.familyPlanIdUSMedium,
    BM: plans.familyPlanIdUSMedium,
    BO: plans.familyPlanIdUSMedium,
    BQ: plans.familyPlanIdUSMedium,
    BR: plans.familyPlanIdUSMedium,
    BS: plans.familyPlanIdUSMedium,
    BT: plans.familyPlanIdUSMedium,
    BY: plans.familyPlanIdUSMedium,
    CD: plans.familyPlanIdUSMedium,
    CI: plans.familyPlanIdUSMedium,
    CL: plans.familyPlanIdUSMedium,
    CM: plans.familyPlanIdUSMedium,
    CN: plans.familyPlanIdUSMedium,
    CO: plans.familyPlanIdUSMedium,
    CR: plans.familyPlanIdUSMedium,
    CU: plans.familyPlanIdUSMedium,
    CV: plans.familyPlanIdUSMedium,
    CW: plans.familyPlanIdUSMedium,
    DO: plans.familyPlanIdUSMedium,
    DZ: plans.familyPlanIdUSMedium,
    EC: plans.familyPlanIdUSMedium,
    EG: plans.familyPlanIdUSMedium,
    EH: plans.familyPlanIdUSMedium,
    ET: plans.familyPlanIdUSMedium,
    FJ: plans.familyPlanIdUSMedium,
    FK: plans.familyPlanIdUSMedium,
    FM: plans.familyPlanIdUSMedium,
    FO: plans.familyPlanIdUSMedium,
    GA: plans.familyPlanIdUSMedium,
    GD: plans.familyPlanIdUSMedium,
    GE: plans.familyPlanIdUSMedium,
    GG: plans.familyPlanIdUSMedium,
    GH: plans.familyPlanIdUSMedium,
    GI: plans.familyPlanIdUSMedium,
    GM: plans.familyPlanIdUSMedium,
    GP: plans.familyPlanIdUSMedium,
    GQ: plans.familyPlanIdUSMedium,
    GR: plans.familyPlanIdUSMedium,
    GT: plans.familyPlanIdUSMedium,
    GU: plans.familyPlanIdUSMedium,
    HK: plans.familyPlanIdUSMedium,
    HN: plans.familyPlanIdUSMedium,
    HR: plans.familyPlanIdUSMedium,
    HT: plans.familyPlanIdUSMedium,
    ID: plans.familyPlanIdUSMedium,
    IL: plans.familyPlanIdUSMedium,
    IN: plans.familyPlanIdUSMedium,
    IQ: plans.familyPlanIdUSMedium,
    IR: plans.familyPlanIdUSMedium,
    IS: plans.familyPlanIdUSMedium,
    JE: plans.familyPlanIdUSMedium,
    JM: plans.familyPlanIdUSMedium,
    JO: plans.familyPlanIdUSMedium,
    JP: plans.familyPlanIdUSMedium,
    KE: plans.familyPlanIdUSMedium,
    KG: plans.familyPlanIdUSMedium,
    KH: plans.familyPlanIdUSMedium,
    KN: plans.familyPlanIdUSMedium,
    KR: plans.familyPlanIdUSMedium,
    KY: plans.familyPlanIdUSMedium,
    LA: plans.familyPlanIdUSMedium,
    LB: plans.familyPlanIdUSMedium,
    LC: plans.familyPlanIdUSMedium,
    LI: plans.familyPlanIdUSMedium,
    LK: plans.familyPlanIdUSMedium,
    LS: plans.familyPlanIdUSMedium,
    LT: plans.familyPlanIdUSMedium,
    LV: plans.familyPlanIdUSMedium,
    LY: plans.familyPlanIdUSMedium,
    MA: plans.familyPlanIdUSMedium,
    MC: plans.familyPlanIdUSMedium,
    MD: plans.familyPlanIdUSMedium,
    ME: plans.familyPlanIdUSMedium,
    MG: plans.familyPlanIdUSMedium,
    MK: plans.familyPlanIdUSMedium,
    ML: plans.familyPlanIdUSMedium,
    MM: plans.familyPlanIdUSMedium,
    MN: plans.familyPlanIdUSMedium,
    MO: plans.familyPlanIdUSMedium,
    MQ: plans.familyPlanIdUSMedium,
    MR: plans.familyPlanIdUSMedium,
    MT: plans.familyPlanIdUSMedium,
    MU: plans.familyPlanIdUSMedium,
    MV: plans.familyPlanIdUSMedium,
    MW: plans.familyPlanIdUSMedium,
    MX: plans.familyPlanIdUSMedium,
    MY: plans.familyPlanIdUSMedium,
    MZ: plans.familyPlanIdUSMedium,
    NA: plans.familyPlanIdUSMedium,
    NC: plans.familyPlanIdUSMedium,
    NE: plans.familyPlanIdUSMedium,
    NF: plans.familyPlanIdUSMedium,
    NG: plans.familyPlanIdUSMedium,
    NI: plans.familyPlanIdUSMedium,
    NP: plans.familyPlanIdUSMedium,
    NZ: plans.familyPlanIdUSMedium,
    PA: plans.familyPlanIdUSMedium,
    PE: plans.familyPlanIdUSMedium,
    PF: plans.familyPlanIdUSMedium,
    PG: plans.familyPlanIdUSMedium,
    PH: plans.familyPlanIdUSMedium,
    PK: plans.familyPlanIdUSMedium,
    PR: plans.familyPlanIdUSMedium,
    PS: plans.familyPlanIdUSMedium,
    PY: plans.familyPlanIdUSMedium,
    RE: plans.familyPlanIdUSMedium,
    RS: plans.familyPlanIdUSMedium,
    RU: plans.familyPlanIdUSMedium,
    RW: plans.familyPlanIdUSMedium,
    SC: plans.familyPlanIdUSMedium,
    SD: plans.familyPlanIdUSMedium,
    SG: plans.familyPlanIdUSMedium,
    SI: plans.familyPlanIdUSMedium,
    SK: plans.familyPlanIdUSMedium,
    SL: plans.familyPlanIdUSMedium,
    SM: plans.familyPlanIdUSMedium,
    SN: plans.familyPlanIdUSMedium,
    SO: plans.familyPlanIdUSMedium,
    SS: plans.familyPlanIdUSMedium,
    SV: plans.familyPlanIdUSMedium,
    SY: plans.familyPlanIdUSMedium,
    SZ: plans.familyPlanIdUSMedium,
    TD: plans.familyPlanIdUSMedium,
    TG: plans.familyPlanIdUSMedium,
    TH: plans.familyPlanIdUSMedium,
    TJ: plans.familyPlanIdUSMedium,
    TL: plans.familyPlanIdUSMedium,
    TN: plans.familyPlanIdUSMedium,
    TR: plans.familyPlanIdUSMedium,
    TV: plans.familyPlanIdUSMedium,
    TW: plans.familyPlanIdUSMedium,
    TZ: plans.familyPlanIdUSMedium,
    UA: plans.familyPlanIdUSMedium,
    UG: plans.familyPlanIdUSMedium,
    UY: plans.familyPlanIdUSMedium,
    UZ: plans.familyPlanIdUSMedium,
    VC: plans.familyPlanIdUSMedium,
    VE: plans.familyPlanIdUSMedium,
    VG: plans.familyPlanIdUSMedium,
    VI: plans.familyPlanIdUSMedium,
    VN: plans.familyPlanIdUSMedium,
    VU: plans.familyPlanIdUSMedium,
    XK: plans.familyPlanIdUSMedium,
    YE: plans.familyPlanIdUSMedium,
    YT: plans.familyPlanIdUSMedium,
    ZA: plans.familyPlanIdUSMedium,
    ZM: plans.familyPlanIdUSMedium,
    ZW: plans.familyPlanIdUSMedium,
    AE: plans.familyPlanIdUS,
    BH: plans.familyPlanIdUS,
    BN: plans.familyPlanIdUS,
    BW: plans.familyPlanIdUS,
    BZ: plans.familyPlanIdUS,
    EE: plans.familyPlanIdUS,
    GY: plans.familyPlanIdUS,
    KW: plans.familyPlanIdUS,
    KZ: plans.familyPlanIdUS,
    LU: plans.familyPlanIdUS,
    OM: plans.familyPlanIdUS,
    QA: plans.familyPlanIdUS,
    SA: plans.familyPlanIdUS,
    SR: plans.familyPlanIdUS,
    TM: plans.familyPlanIdUS,
    TT: plans.familyPlanIdUS,
    AT: plans.familyPlanIdEU,
    BE: plans.familyPlanIdEU,
    CY: plans.familyPlanIdEU,
    DK: plans.familyPlanIdEU,
    FI: plans.familyPlanIdEU,
    FR: plans.familyPlanIdEU,
    DE: plans.familyPlanIdEU,
    IT: plans.familyPlanIdEU,
    IE: plans.familyPlanIdEU,
    NL: plans.familyPlanIdEU,
    NO: plans.familyPlanIdEU,
    PL: plans.familyPlanIdEU,
    ES: plans.familyPlanIdEU,
    SE: plans.familyPlanIdEU,
    CH: plans.familyPlanIdEU,
    CZ: plans.familyPlanIdEU,
    HU: plans.familyPlanIdEU,
    PT: plans.familyPlanIdEU,
    BG: plans.familyPlanIdEU,
    RO: plans.familyPlanIdEU,
};
const familyAddonsForLocations = {
    AU: addons.familyAddonsAU,
    CA: addons.familyAddonsCA,
    EU: addons.familyAddonsEU,
    GB: addons.familyAddonsGB,
    US: addons.familyAddonsUS,
    AD: addons.familyAddonsUSDMedium,
    AF: addons.familyAddonsUSDMedium,
    AG: addons.familyAddonsUSDMedium,
    AL: addons.familyAddonsUSDMedium,
    AM: addons.familyAddonsUSDMedium,
    AO: addons.familyAddonsUSDMedium,
    AQ: addons.familyAddonsUSDMedium,
    AR: addons.familyAddonsUSDMedium,
    AW: addons.familyAddonsUSDMedium,
    AZ: addons.familyAddonsUSDMedium,
    BA: addons.familyAddonsUSDMedium,
    BB: addons.familyAddonsUSDMedium,
    BD: addons.familyAddonsUSDMedium,
    BF: addons.familyAddonsUSDMedium,
    BI: addons.familyAddonsUSDMedium,
    BJ: addons.familyAddonsUSDMedium,
    BM: addons.familyAddonsUSDMedium,
    BO: addons.familyAddonsUSDMedium,
    BQ: addons.familyAddonsUSDMedium,
    BR: addons.familyAddonsUSDMedium,
    BS: addons.familyAddonsUSDMedium,
    BT: addons.familyAddonsUSDMedium,
    BY: addons.familyAddonsUSDMedium,
    CD: addons.familyAddonsUSDMedium,
    CI: addons.familyAddonsUSDMedium,
    CL: addons.familyAddonsUSDMedium,
    CM: addons.familyAddonsUSDMedium,
    CN: addons.familyAddonsUSDMedium,
    CO: addons.familyAddonsUSDMedium,
    CR: addons.familyAddonsUSDMedium,
    CU: addons.familyAddonsUSDMedium,
    CV: addons.familyAddonsUSDMedium,
    CW: addons.familyAddonsUSDMedium,
    DO: addons.familyAddonsUSDMedium,
    DZ: addons.familyAddonsUSDMedium,
    EC: addons.familyAddonsUSDMedium,
    EG: addons.familyAddonsUSDMedium,
    EH: addons.familyAddonsUSDMedium,
    ET: addons.familyAddonsUSDMedium,
    FJ: addons.familyAddonsUSDMedium,
    FK: addons.familyAddonsUSDMedium,
    FM: addons.familyAddonsUSDMedium,
    FO: addons.familyAddonsUSDMedium,
    GA: addons.familyAddonsUSDMedium,
    GD: addons.familyAddonsUSDMedium,
    GE: addons.familyAddonsUSDMedium,
    GG: addons.familyAddonsUSDMedium,
    GH: addons.familyAddonsUSDMedium,
    GI: addons.familyAddonsUSDMedium,
    GM: addons.familyAddonsUSDMedium,
    GP: addons.familyAddonsUSDMedium,
    GQ: addons.familyAddonsUSDMedium,
    GR: addons.familyAddonsUSDMedium,
    GT: addons.familyAddonsUSDMedium,
    GU: addons.familyAddonsUSDMedium,
    HK: addons.familyAddonsUSDMedium,
    HN: addons.familyAddonsUSDMedium,
    HR: addons.familyAddonsUSDMedium,
    HT: addons.familyAddonsUSDMedium,
    ID: addons.familyAddonsUSDMedium,
    IL: addons.familyAddonsUSDMedium,
    IN: addons.familyAddonsUSDMedium,
    IQ: addons.familyAddonsUSDMedium,
    IR: addons.familyAddonsUSDMedium,
    IS: addons.familyAddonsUSDMedium,
    JE: addons.familyAddonsUSDMedium,
    JM: addons.familyAddonsUSDMedium,
    JO: addons.familyAddonsUSDMedium,
    JP: addons.familyAddonsUSDMedium,
    KE: addons.familyAddonsUSDMedium,
    KG: addons.familyAddonsUSDMedium,
    KH: addons.familyAddonsUSDMedium,
    KN: addons.familyAddonsUSDMedium,
    KR: addons.familyAddonsUSDMedium,
    KY: addons.familyAddonsUSDMedium,
    LA: addons.familyAddonsUSDMedium,
    LB: addons.familyAddonsUSDMedium,
    LC: addons.familyAddonsUSDMedium,
    LI: addons.familyAddonsUSDMedium,
    LK: addons.familyAddonsUSDMedium,
    LS: addons.familyAddonsUSDMedium,
    LT: addons.familyAddonsUSDMedium,
    LV: addons.familyAddonsUSDMedium,
    LY: addons.familyAddonsUSDMedium,
    MA: addons.familyAddonsUSDMedium,
    MC: addons.familyAddonsUSDMedium,
    MD: addons.familyAddonsUSDMedium,
    ME: addons.familyAddonsUSDMedium,
    MG: addons.familyAddonsUSDMedium,
    MK: addons.familyAddonsUSDMedium,
    ML: addons.familyAddonsUSDMedium,
    MM: addons.familyAddonsUSDMedium,
    MN: addons.familyAddonsUSDMedium,
    MO: addons.familyAddonsUSDMedium,
    MQ: addons.familyAddonsUSDMedium,
    MR: addons.familyAddonsUSDMedium,
    MT: addons.familyAddonsUSDMedium,
    MU: addons.familyAddonsUSDMedium,
    MV: addons.familyAddonsUSDMedium,
    MW: addons.familyAddonsUSDMedium,
    MX: addons.familyAddonsUSDMedium,
    MY: addons.familyAddonsUSDMedium,
    MZ: addons.familyAddonsUSDMedium,
    NA: addons.familyAddonsUSDMedium,
    NC: addons.familyAddonsUSDMedium,
    NE: addons.familyAddonsUSDMedium,
    NF: addons.familyAddonsUSDMedium,
    NG: addons.familyAddonsUSDMedium,
    NI: addons.familyAddonsUSDMedium,
    NP: addons.familyAddonsUSDMedium,
    NZ: addons.familyAddonsUSDMedium,
    PA: addons.familyAddonsUSDMedium,
    PE: addons.familyAddonsUSDMedium,
    PF: addons.familyAddonsUSDMedium,
    PG: addons.familyAddonsUSDMedium,
    PH: addons.familyAddonsUSDMedium,
    PK: addons.familyAddonsUSDMedium,
    PR: addons.familyAddonsUSDMedium,
    PS: addons.familyAddonsUSDMedium,
    PY: addons.familyAddonsUSDMedium,
    RE: addons.familyAddonsUSDMedium,
    RS: addons.familyAddonsUSDMedium,
    RU: addons.familyAddonsUSDMedium,
    RW: addons.familyAddonsUSDMedium,
    SC: addons.familyAddonsUSDMedium,
    SD: addons.familyAddonsUSDMedium,
    SG: addons.familyAddonsUSDMedium,
    SI: addons.familyAddonsUSDMedium,
    SK: addons.familyAddonsUSDMedium,
    SL: addons.familyAddonsUSDMedium,
    SM: addons.familyAddonsUSDMedium,
    SN: addons.familyAddonsUSDMedium,
    SO: addons.familyAddonsUSDMedium,
    SS: addons.familyAddonsUSDMedium,
    SV: addons.familyAddonsUSDMedium,
    SY: addons.familyAddonsUSDMedium,
    SZ: addons.familyAddonsUSDMedium,
    TD: addons.familyAddonsUSDMedium,
    TG: addons.familyAddonsUSDMedium,
    TH: addons.familyAddonsUSDMedium,
    TJ: addons.familyAddonsUSDMedium,
    TL: addons.familyAddonsUSDMedium,
    TN: addons.familyAddonsUSDMedium,
    TR: addons.familyAddonsUSDMedium,
    TV: addons.familyAddonsUSDMedium,
    TW: addons.familyAddonsUSDMedium,
    TZ: addons.familyAddonsUSDMedium,
    UA: addons.familyAddonsUSDMedium,
    UG: addons.familyAddonsUSDMedium,
    UY: addons.familyAddonsUSDMedium,
    UZ: addons.familyAddonsUSDMedium,
    VC: addons.familyAddonsUSDMedium,
    VE: addons.familyAddonsUSDMedium,
    VG: addons.familyAddonsUSDMedium,
    VI: addons.familyAddonsUSDMedium,
    VN: addons.familyAddonsUSDMedium,
    VU: addons.familyAddonsUSDMedium,
    XK: addons.familyAddonsUSDMedium,
    YE: addons.familyAddonsUSDMedium,
    YT: addons.familyAddonsUSDMedium,
    ZA: addons.familyAddonsUSDMedium,
    ZM: addons.familyAddonsUSDMedium,
    ZW: addons.familyAddonsUSDMedium,
    AE: addons.familyAddonsUS,
    BH: addons.familyAddonsUS,
    BN: addons.familyAddonsUS,
    BW: addons.familyAddonsUS,
    BZ: addons.familyAddonsUS,
    EE: addons.familyAddonsUS,
    GY: addons.familyAddonsUS,
    KW: addons.familyAddonsUS,
    KZ: addons.familyAddonsUS,
    LU: addons.familyAddonsUS,
    OM: addons.familyAddonsUS,
    QA: addons.familyAddonsUS,
    SA: addons.familyAddonsUS,
    SR: addons.familyAddonsUS,
    TM: addons.familyAddonsUS,
    TT: addons.familyAddonsUS,
    AT: addons.familyAddonsEU,
    BE: addons.familyAddonsEU,
    CY: addons.familyAddonsEU,
    DK: addons.familyAddonsEU,
    FI: addons.familyAddonsEU,
    FR: addons.familyAddonsEU,
    DE: addons.familyAddonsEU,
    IT: addons.familyAddonsEU,
    IE: addons.familyAddonsEU,
    NL: addons.familyAddonsEU,
    NO: addons.familyAddonsEU,
    PL: addons.familyAddonsEU,
    ES: addons.familyAddonsEU,
    SE: addons.familyAddonsEU,
    CH: addons.familyAddonsEU,
    CZ: addons.familyAddonsEU,
    HU: addons.familyAddonsEU,
    PT: addons.familyAddonsEU,
    BG: addons.familyAddonsEU,
    RO: addons.familyAddonsEU,
};
const businessPlanOptions = {
    AU: plans.businessPlanIdAU,
    CA: plans.businessPlanIdCA,
    EU: plans.businessPlanIdEU,
    GB: plans.businessPlanIdGB,
    US: plans.businessPlanIdUS,
    AD: plans.businessPlanIdUSDMedium,
    AF: plans.businessPlanIdUSDMedium,
    AG: plans.businessPlanIdUSDMedium,
    AL: plans.businessPlanIdUSDMedium,
    AM: plans.businessPlanIdUSDMedium,
    AO: plans.businessPlanIdUSDMedium,
    AQ: plans.businessPlanIdUSDMedium,
    AR: plans.businessPlanIdUSDMedium,
    AW: plans.businessPlanIdUSDMedium,
    AZ: plans.businessPlanIdUSDMedium,
    BA: plans.businessPlanIdUSDMedium,
    BB: plans.businessPlanIdUSDMedium,
    BD: plans.businessPlanIdUSDMedium,
    BF: plans.businessPlanIdUSDMedium,
    BI: plans.businessPlanIdUSDMedium,
    BJ: plans.businessPlanIdUSDMedium,
    BM: plans.businessPlanIdUSDMedium,
    BO: plans.businessPlanIdUSDMedium,
    BQ: plans.businessPlanIdUSDMedium,
    BR: plans.businessPlanIdUSDMedium,
    BS: plans.businessPlanIdUSDMedium,
    BT: plans.businessPlanIdUSDMedium,
    BY: plans.businessPlanIdUSDMedium,
    CD: plans.businessPlanIdUSDMedium,
    CI: plans.businessPlanIdUSDMedium,
    CL: plans.businessPlanIdUSDMedium,
    CM: plans.businessPlanIdUSDMedium,
    CN: plans.businessPlanIdUSDMedium,
    CO: plans.businessPlanIdUSDMedium,
    CR: plans.businessPlanIdUSDMedium,
    CU: plans.businessPlanIdUSDMedium,
    CV: plans.businessPlanIdUSDMedium,
    CW: plans.businessPlanIdUSDMedium,
    DO: plans.businessPlanIdUSDMedium,
    DZ: plans.businessPlanIdUSDMedium,
    EC: plans.businessPlanIdUSDMedium,
    EG: plans.businessPlanIdUSDMedium,
    EH: plans.businessPlanIdUSDMedium,
    ET: plans.businessPlanIdUSDMedium,
    FJ: plans.businessPlanIdUSDMedium,
    FK: plans.businessPlanIdUSDMedium,
    FM: plans.businessPlanIdUSDMedium,
    FO: plans.businessPlanIdUSDMedium,
    GA: plans.businessPlanIdUSDMedium,
    GD: plans.businessPlanIdUSDMedium,
    GE: plans.businessPlanIdUSDMedium,
    GG: plans.businessPlanIdUSDMedium,
    GH: plans.businessPlanIdUSDMedium,
    GI: plans.businessPlanIdUSDMedium,
    GM: plans.businessPlanIdUSDMedium,
    GP: plans.businessPlanIdUSDMedium,
    GQ: plans.businessPlanIdUSDMedium,
    GR: plans.businessPlanIdUSDMedium,
    GT: plans.businessPlanIdUSDMedium,
    GU: plans.businessPlanIdUSDMedium,
    HK: plans.businessPlanIdUSDMedium,
    HN: plans.businessPlanIdUSDMedium,
    HR: plans.businessPlanIdUSDMedium,
    HT: plans.businessPlanIdUSDMedium,
    ID: plans.businessPlanIdUSDMedium,
    IL: plans.businessPlanIdUSDMedium,
    IN: plans.businessPlanIdUSDMedium,
    IQ: plans.businessPlanIdUSDMedium,
    IR: plans.businessPlanIdUSDMedium,
    IS: plans.businessPlanIdUSDMedium,
    JE: plans.businessPlanIdUSDMedium,
    JM: plans.businessPlanIdUSDMedium,
    JO: plans.businessPlanIdUSDMedium,
    JP: plans.businessPlanIdUSDMedium,
    KE: plans.businessPlanIdUSDMedium,
    KG: plans.businessPlanIdUSDMedium,
    KH: plans.businessPlanIdUSDMedium,
    KN: plans.businessPlanIdUSDMedium,
    KR: plans.businessPlanIdUSDMedium,
    KY: plans.businessPlanIdUSDMedium,
    LA: plans.businessPlanIdUSDMedium,
    LB: plans.businessPlanIdUSDMedium,
    LC: plans.businessPlanIdUSDMedium,
    LI: plans.businessPlanIdUSDMedium,
    LK: plans.businessPlanIdUSDMedium,
    LS: plans.businessPlanIdUSDMedium,
    LT: plans.businessPlanIdUSDMedium,
    LV: plans.businessPlanIdUSDMedium,
    LY: plans.businessPlanIdUSDMedium,
    MA: plans.businessPlanIdUSDMedium,
    MC: plans.businessPlanIdUSDMedium,
    MD: plans.businessPlanIdUSDMedium,
    ME: plans.businessPlanIdUSDMedium,
    MG: plans.businessPlanIdUSDMedium,
    MK: plans.businessPlanIdUSDMedium,
    ML: plans.businessPlanIdUSDMedium,
    MM: plans.businessPlanIdUSDMedium,
    MN: plans.businessPlanIdUSDMedium,
    MO: plans.businessPlanIdUSDMedium,
    MQ: plans.businessPlanIdUSDMedium,
    MR: plans.businessPlanIdUSDMedium,
    MT: plans.businessPlanIdUSDMedium,
    MU: plans.businessPlanIdUSDMedium,
    MV: plans.businessPlanIdUSDMedium,
    MW: plans.businessPlanIdUSDMedium,
    MX: plans.businessPlanIdUSDMedium,
    MY: plans.businessPlanIdUSDMedium,
    MZ: plans.businessPlanIdUSDMedium,
    NA: plans.businessPlanIdUSDMedium,
    NC: plans.businessPlanIdUSDMedium,
    NE: plans.businessPlanIdUSDMedium,
    NF: plans.businessPlanIdUSDMedium,
    NG: plans.businessPlanIdUSDMedium,
    NI: plans.businessPlanIdUSDMedium,
    NP: plans.businessPlanIdUSDMedium,
    NZ: plans.businessPlanIdUSDMedium,
    PA: plans.businessPlanIdUSDMedium,
    PE: plans.businessPlanIdUSDMedium,
    PF: plans.businessPlanIdUSDMedium,
    PG: plans.businessPlanIdUSDMedium,
    PH: plans.businessPlanIdUSDMedium,
    PK: plans.businessPlanIdUSDMedium,
    PR: plans.businessPlanIdUSDMedium,
    PS: plans.businessPlanIdUSDMedium,
    PY: plans.businessPlanIdUSDMedium,
    RE: plans.businessPlanIdUSDMedium,
    RS: plans.businessPlanIdUSDMedium,
    RU: plans.businessPlanIdUSDMedium,
    RW: plans.businessPlanIdUSDMedium,
    SC: plans.businessPlanIdUSDMedium,
    SD: plans.businessPlanIdUSDMedium,
    SG: plans.businessPlanIdUSDMedium,
    SI: plans.businessPlanIdUSDMedium,
    SK: plans.businessPlanIdUSDMedium,
    SL: plans.businessPlanIdUSDMedium,
    SM: plans.businessPlanIdUSDMedium,
    SN: plans.businessPlanIdUSDMedium,
    SO: plans.businessPlanIdUSDMedium,
    SS: plans.businessPlanIdUSDMedium,
    SV: plans.businessPlanIdUSDMedium,
    SY: plans.businessPlanIdUSDMedium,
    SZ: plans.businessPlanIdUSDMedium,
    TD: plans.businessPlanIdUSDMedium,
    TG: plans.businessPlanIdUSDMedium,
    TH: plans.businessPlanIdUSDMedium,
    TJ: plans.businessPlanIdUSDMedium,
    TL: plans.businessPlanIdUSDMedium,
    TN: plans.businessPlanIdUSDMedium,
    TR: plans.businessPlanIdUSDMedium,
    TV: plans.businessPlanIdUSDMedium,
    TW: plans.businessPlanIdUSDMedium,
    TZ: plans.businessPlanIdUSDMedium,
    UA: plans.businessPlanIdUSDMedium,
    UG: plans.businessPlanIdUSDMedium,
    UY: plans.businessPlanIdUSDMedium,
    UZ: plans.businessPlanIdUSDMedium,
    VC: plans.businessPlanIdUSDMedium,
    VE: plans.businessPlanIdUSDMedium,
    VG: plans.businessPlanIdUSDMedium,
    VI: plans.businessPlanIdUSDMedium,
    VN: plans.businessPlanIdUSDMedium,
    VU: plans.businessPlanIdUSDMedium,
    XK: plans.businessPlanIdUSDMedium,
    YE: plans.businessPlanIdUSDMedium,
    YT: plans.businessPlanIdUSDMedium,
    ZA: plans.businessPlanIdUSDMedium,
    ZM: plans.businessPlanIdUSDMedium,
    ZW: plans.businessPlanIdUSDMedium,
    AE: plans.businessPlanIdUS,
    BH: plans.businessPlanIdUS,
    BN: plans.businessPlanIdUS,
    BW: plans.businessPlanIdUS,
    BZ: plans.businessPlanIdUS,
    EE: plans.businessPlanIdUS,
    GY: plans.businessPlanIdUS,
    KW: plans.businessPlanIdUS,
    KZ: plans.businessPlanIdUS,
    LU: plans.businessPlanIdUS,
    OM: plans.businessPlanIdUS,
    QA: plans.businessPlanIdUS,
    SA: plans.businessPlanIdUS,
    SR: plans.businessPlanIdUS,
    TM: plans.businessPlanIdUS,
    TT: plans.businessPlanIdUS,
    AT: plans.businessPlanIdEU,
    BE: plans.businessPlanIdEU,
    CY: plans.businessPlanIdEU,
    DK: plans.businessPlanIdEU,
    FI: plans.businessPlanIdEU,
    FR: plans.businessPlanIdEU,
    DE: plans.businessPlanIdEU,
    IT: plans.businessPlanIdEU,
    IE: plans.businessPlanIdEU,
    NL: plans.businessPlanIdEU,
    NO: plans.businessPlanIdEU,
    PL: plans.businessPlanIdEU,
    ES: plans.businessPlanIdEU,
    SE: plans.businessPlanIdEU,
    CH: plans.businessPlanIdEU,
    CZ: plans.businessPlanIdEU,
    HU: plans.businessPlanIdEU,
    PT: plans.businessPlanIdEU,
    BG: plans.businessPlanIdEU,
    RO: plans.businessPlanIdEU,
};
const businessAddonOptions = {
    AU: addons.businessAddonsAU,
    CA: addons.businessAddonsCA,
    EU: addons.businessAddonsEU,
    GB: addons.businessAddonsGB,
    US: addons.businessAddonsUS,
    AD: addons.businessAddonsUSDMedium,
    AF: addons.businessAddonsUSDMedium,
    AG: addons.businessAddonsUSDMedium,
    AL: addons.businessAddonsUSDMedium,
    AM: addons.businessAddonsUSDMedium,
    AO: addons.businessAddonsUSDMedium,
    AQ: addons.businessAddonsUSDMedium,
    AR: addons.businessAddonsUSDMedium,
    AW: addons.businessAddonsUSDMedium,
    AZ: addons.businessAddonsUSDMedium,
    BA: addons.businessAddonsUSDMedium,
    BB: addons.businessAddonsUSDMedium,
    BD: addons.businessAddonsUSDMedium,
    BF: addons.businessAddonsUSDMedium,
    BI: addons.businessAddonsUSDMedium,
    BJ: addons.businessAddonsUSDMedium,
    BM: addons.businessAddonsUSDMedium,
    BO: addons.businessAddonsUSDMedium,
    BQ: addons.businessAddonsUSDMedium,
    BR: addons.businessAddonsUSDMedium,
    BS: addons.businessAddonsUSDMedium,
    BT: addons.businessAddonsUSDMedium,
    BY: addons.businessAddonsUSDMedium,
    CD: addons.businessAddonsUSDMedium,
    CI: addons.businessAddonsUSDMedium,
    CL: addons.businessAddonsUSDMedium,
    CM: addons.businessAddonsUSDMedium,
    CN: addons.businessAddonsUSDMedium,
    CO: addons.businessAddonsUSDMedium,
    CR: addons.businessAddonsUSDMedium,
    CU: addons.businessAddonsUSDMedium,
    CV: addons.businessAddonsUSDMedium,
    CW: addons.businessAddonsUSDMedium,
    DO: addons.businessAddonsUSDMedium,
    DZ: addons.businessAddonsUSDMedium,
    EC: addons.businessAddonsUSDMedium,
    EG: addons.businessAddonsUSDMedium,
    EH: addons.businessAddonsUSDMedium,
    ET: addons.businessAddonsUSDMedium,
    FJ: addons.businessAddonsUSDMedium,
    FK: addons.businessAddonsUSDMedium,
    FM: addons.businessAddonsUSDMedium,
    FO: addons.businessAddonsUSDMedium,
    GA: addons.businessAddonsUSDMedium,
    GD: addons.businessAddonsUSDMedium,
    GE: addons.businessAddonsUSDMedium,
    GG: addons.businessAddonsUSDMedium,
    GH: addons.businessAddonsUSDMedium,
    GI: addons.businessAddonsUSDMedium,
    GM: addons.businessAddonsUSDMedium,
    GP: addons.businessAddonsUSDMedium,
    GQ: addons.businessAddonsUSDMedium,
    GR: addons.businessAddonsUSDMedium,
    GT: addons.businessAddonsUSDMedium,
    GU: addons.businessAddonsUSDMedium,
    HK: addons.businessAddonsUSDMedium,
    HN: addons.businessAddonsUSDMedium,
    HR: addons.businessAddonsUSDMedium,
    HT: addons.businessAddonsUSDMedium,
    ID: addons.businessAddonsUSDMedium,
    IL: addons.businessAddonsUSDMedium,
    IN: addons.businessAddonsUSDMedium,
    IQ: addons.businessAddonsUSDMedium,
    IR: addons.businessAddonsUSDMedium,
    IS: addons.businessAddonsUSDMedium,
    JE: addons.businessAddonsUSDMedium,
    JM: addons.businessAddonsUSDMedium,
    JO: addons.businessAddonsUSDMedium,
    JP: addons.businessAddonsUSDMedium,
    KE: addons.businessAddonsUSDMedium,
    KG: addons.businessAddonsUSDMedium,
    KH: addons.businessAddonsUSDMedium,
    KN: addons.businessAddonsUSDMedium,
    KR: addons.businessAddonsUSDMedium,
    KY: addons.businessAddonsUSDMedium,
    LA: addons.businessAddonsUSDMedium,
    LB: addons.businessAddonsUSDMedium,
    LC: addons.businessAddonsUSDMedium,
    LI: addons.businessAddonsUSDMedium,
    LK: addons.businessAddonsUSDMedium,
    LS: addons.businessAddonsUSDMedium,
    LT: addons.businessAddonsUSDMedium,
    LV: addons.businessAddonsUSDMedium,
    LY: addons.businessAddonsUSDMedium,
    MA: addons.businessAddonsUSDMedium,
    MC: addons.businessAddonsUSDMedium,
    MD: addons.businessAddonsUSDMedium,
    ME: addons.businessAddonsUSDMedium,
    MG: addons.businessAddonsUSDMedium,
    MK: addons.businessAddonsUSDMedium,
    ML: addons.businessAddonsUSDMedium,
    MM: addons.businessAddonsUSDMedium,
    MN: addons.businessAddonsUSDMedium,
    MO: addons.businessAddonsUSDMedium,
    MQ: addons.businessAddonsUSDMedium,
    MR: addons.businessAddonsUSDMedium,
    MT: addons.businessAddonsUSDMedium,
    MU: addons.businessAddonsUSDMedium,
    MV: addons.businessAddonsUSDMedium,
    MW: addons.businessAddonsUSDMedium,
    MX: addons.businessAddonsUSDMedium,
    MY: addons.businessAddonsUSDMedium,
    MZ: addons.businessAddonsUSDMedium,
    NA: addons.businessAddonsUSDMedium,
    NC: addons.businessAddonsUSDMedium,
    NE: addons.businessAddonsUSDMedium,
    NF: addons.businessAddonsUSDMedium,
    NG: addons.businessAddonsUSDMedium,
    NI: addons.businessAddonsUSDMedium,
    NP: addons.businessAddonsUSDMedium,
    NZ: addons.businessAddonsUSDMedium,
    PA: addons.businessAddonsUSDMedium,
    PE: addons.businessAddonsUSDMedium,
    PF: addons.businessAddonsUSDMedium,
    PG: addons.businessAddonsUSDMedium,
    PH: addons.businessAddonsUSDMedium,
    PK: addons.businessAddonsUSDMedium,
    PR: addons.businessAddonsUSDMedium,
    PS: addons.businessAddonsUSDMedium,
    PY: addons.businessAddonsUSDMedium,
    RE: addons.businessAddonsUSDMedium,
    RS: addons.businessAddonsUSDMedium,
    RU: addons.businessAddonsUSDMedium,
    RW: addons.businessAddonsUSDMedium,
    SC: addons.businessAddonsUSDMedium,
    SD: addons.businessAddonsUSDMedium,
    SG: addons.businessAddonsUSDMedium,
    SI: addons.businessAddonsUSDMedium,
    SK: addons.businessAddonsUSDMedium,
    SL: addons.businessAddonsUSDMedium,
    SM: addons.businessAddonsUSDMedium,
    SN: addons.businessAddonsUSDMedium,
    SO: addons.businessAddonsUSDMedium,
    SS: addons.businessAddonsUSDMedium,
    SV: addons.businessAddonsUSDMedium,
    SY: addons.businessAddonsUSDMedium,
    SZ: addons.businessAddonsUSDMedium,
    TD: addons.businessAddonsUSDMedium,
    TG: addons.businessAddonsUSDMedium,
    TH: addons.businessAddonsUSDMedium,
    TJ: addons.businessAddonsUSDMedium,
    TL: addons.businessAddonsUSDMedium,
    TN: addons.businessAddonsUSDMedium,
    TR: addons.businessAddonsUSDMedium,
    TV: addons.businessAddonsUSDMedium,
    TW: addons.businessAddonsUSDMedium,
    TZ: addons.businessAddonsUSDMedium,
    UA: addons.businessAddonsUSDMedium,
    UG: addons.businessAddonsUSDMedium,
    UY: addons.businessAddonsUSDMedium,
    UZ: addons.businessAddonsUSDMedium,
    VC: addons.businessAddonsUSDMedium,
    VE: addons.businessAddonsUSDMedium,
    VG: addons.businessAddonsUSDMedium,
    VI: addons.businessAddonsUSDMedium,
    VN: addons.businessAddonsUSDMedium,
    VU: addons.businessAddonsUSDMedium,
    XK: addons.businessAddonsUSDMedium,
    YE: addons.businessAddonsUSDMedium,
    YT: addons.businessAddonsUSDMedium,
    ZA: addons.businessAddonsUSDMedium,
    ZM: addons.businessAddonsUSDMedium,
    ZW: addons.businessAddonsUSDMedium,
    AE: addons.businessAddonsUS,
    BH: addons.businessAddonsUS,
    BN: addons.businessAddonsUS,
    BW: addons.businessAddonsUS,
    BZ: addons.businessAddonsUS,
    EE: addons.businessAddonsUS,
    GY: addons.businessAddonsUS,
    KW: addons.businessAddonsUS,
    KZ: addons.businessAddonsUS,
    LU: addons.businessAddonsUS,
    OM: addons.businessAddonsUS,
    QA: addons.businessAddonsUS,
    SA: addons.businessAddonsUS,
    SR: addons.businessAddonsUS,
    TM: addons.businessAddonsUS,
    TT: addons.businessAddonsUS,
    AT: addons.businessAddonsEU,
    BE: addons.businessAddonsEU,
    CY: addons.businessAddonsEU,
    DK: addons.businessAddonsEU,
    FI: addons.businessAddonsEU,
    FR: addons.businessAddonsEU,
    DE: addons.businessAddonsEU,
    IT: addons.businessAddonsEU,
    IE: addons.businessAddonsEU,
    NL: addons.businessAddonsEU,
    NO: addons.businessAddonsEU,
    PL: addons.businessAddonsEU,
    ES: addons.businessAddonsEU,
    SE: addons.businessAddonsEU,
    CH: addons.businessAddonsEU,
    CZ: addons.businessAddonsEU,
    HU: addons.businessAddonsEU,
    PT: addons.businessAddonsEU,
    BG: addons.businessAddonsEU,
    RO: addons.businessAddonsEU,
};
exports.locationConsumptions = {
    AD: Consumptions.HIGH,
    AE: Consumptions.VERY_HIGH,
    AF: Consumptions.HIGH,
    AG: Consumptions.HIGH,
    AL: Consumptions.HIGH,
    AM: Consumptions.HIGH,
    AO: Consumptions.HIGH,
    AQ: Consumptions.HIGH,
    AR: Consumptions.HIGH,
    AT: Consumptions.HIGH,
    AU: Consumptions.VERY_HIGH,
    AW: Consumptions.HIGH,
    AZ: Consumptions.HIGH,
    BA: Consumptions.HIGH,
    BB: Consumptions.HIGH,
    BD: Consumptions.HIGH,
    BE: Consumptions.HIGH,
    BF: Consumptions.HIGH,
    BG: Consumptions.HIGH,
    BH: Consumptions.VERY_HIGH,
    BI: Consumptions.HIGH,
    BJ: Consumptions.HIGH,
    BM: Consumptions.HIGH,
    BN: Consumptions.VERY_HIGH,
    BO: Consumptions.HIGH,
    BQ: Consumptions.HIGH,
    BR: Consumptions.HIGH,
    BS: Consumptions.HIGH,
    BT: Consumptions.HIGH,
    BW: Consumptions.VERY_HIGH,
    BY: Consumptions.HIGH,
    BZ: Consumptions.VERY_HIGH,
    CA: Consumptions.VERY_HIGH,
    CD: Consumptions.HIGH,
    CH: Consumptions.HIGH,
    CI: Consumptions.HIGH,
    CL: Consumptions.HIGH,
    CM: Consumptions.HIGH,
    CN: Consumptions.HIGH,
    CO: Consumptions.HIGH,
    CR: Consumptions.HIGH,
    CU: Consumptions.HIGH,
    CV: Consumptions.HIGH,
    CW: Consumptions.HIGH,
    CY: Consumptions.HIGH,
    CZ: Consumptions.HIGH,
    DE: Consumptions.HIGH,
    DK: Consumptions.HIGH,
    DO: Consumptions.HIGH,
    DZ: Consumptions.HIGH,
    EC: Consumptions.HIGH,
    EE: Consumptions.VERY_HIGH,
    EG: Consumptions.HIGH,
    EH: Consumptions.HIGH,
    ES: Consumptions.HIGH,
    ET: Consumptions.HIGH,
    EU: Consumptions.HIGH,
    FI: Consumptions.HIGH,
    FJ: Consumptions.HIGH,
    FK: Consumptions.HIGH,
    FM: Consumptions.HIGH,
    FO: Consumptions.HIGH,
    FR: Consumptions.HIGH,
    GA: Consumptions.HIGH,
    GB: Consumptions.HIGH,
    GD: Consumptions.HIGH,
    GE: Consumptions.HIGH,
    GG: Consumptions.HIGH,
    GH: Consumptions.HIGH,
    GI: Consumptions.HIGH,
    GM: Consumptions.HIGH,
    GP: Consumptions.HIGH,
    GQ: Consumptions.HIGH,
    GR: Consumptions.HIGH,
    GT: Consumptions.HIGH,
    GU: Consumptions.HIGH,
    GY: Consumptions.VERY_HIGH,
    HK: Consumptions.HIGH,
    HN: Consumptions.HIGH,
    HR: Consumptions.HIGH,
    HT: Consumptions.HIGH,
    HU: Consumptions.HIGH,
    ID: Consumptions.HIGH,
    IE: Consumptions.HIGH,
    IL: Consumptions.HIGH,
    IN: Consumptions.HIGH,
    IQ: Consumptions.HIGH,
    IR: Consumptions.HIGH,
    IS: Consumptions.HIGH,
    IT: Consumptions.HIGH,
    JE: Consumptions.HIGH,
    JM: Consumptions.HIGH,
    JO: Consumptions.HIGH,
    JP: Consumptions.HIGH,
    KE: Consumptions.HIGH,
    KG: Consumptions.HIGH,
    KH: Consumptions.HIGH,
    KN: Consumptions.HIGH,
    KR: Consumptions.HIGH,
    KW: Consumptions.VERY_HIGH,
    KY: Consumptions.HIGH,
    KZ: Consumptions.VERY_HIGH,
    LA: Consumptions.HIGH,
    LB: Consumptions.HIGH,
    LC: Consumptions.HIGH,
    LI: Consumptions.HIGH,
    LK: Consumptions.HIGH,
    LS: Consumptions.HIGH,
    LT: Consumptions.HIGH,
    LU: Consumptions.VERY_HIGH,
    LV: Consumptions.HIGH,
    LY: Consumptions.HIGH,
    MA: Consumptions.HIGH,
    MC: Consumptions.HIGH,
    MD: Consumptions.HIGH,
    ME: Consumptions.HIGH,
    MG: Consumptions.HIGH,
    MK: Consumptions.HIGH,
    ML: Consumptions.HIGH,
    MM: Consumptions.HIGH,
    MN: Consumptions.HIGH,
    MO: Consumptions.HIGH,
    MQ: Consumptions.HIGH,
    MR: Consumptions.HIGH,
    MT: Consumptions.HIGH,
    MU: Consumptions.HIGH,
    MV: Consumptions.HIGH,
    MW: Consumptions.HIGH,
    MX: Consumptions.HIGH,
    MY: Consumptions.HIGH,
    MZ: Consumptions.HIGH,
    NA: Consumptions.HIGH,
    NC: Consumptions.HIGH,
    NE: Consumptions.HIGH,
    NF: Consumptions.HIGH,
    NG: Consumptions.HIGH,
    NI: Consumptions.HIGH,
    NL: Consumptions.HIGH,
    NO: Consumptions.HIGH,
    NP: Consumptions.HIGH,
    NZ: Consumptions.HIGH,
    OM: Consumptions.VERY_HIGH,
    PA: Consumptions.HIGH,
    PE: Consumptions.HIGH,
    PF: Consumptions.HIGH,
    PG: Consumptions.HIGH,
    PH: Consumptions.HIGH,
    PK: Consumptions.HIGH,
    PL: Consumptions.HIGH,
    PR: Consumptions.HIGH,
    PS: Consumptions.HIGH,
    PT: Consumptions.HIGH,
    PY: Consumptions.HIGH,
    QA: Consumptions.VERY_HIGH,
    RE: Consumptions.HIGH,
    RO: Consumptions.HIGH,
    RS: Consumptions.HIGH,
    RU: Consumptions.HIGH,
    RW: Consumptions.HIGH,
    SA: Consumptions.VERY_HIGH,
    SC: Consumptions.HIGH,
    SD: Consumptions.HIGH,
    SE: Consumptions.HIGH,
    SG: Consumptions.HIGH,
    SI: Consumptions.HIGH,
    SK: Consumptions.HIGH,
    SL: Consumptions.HIGH,
    SM: Consumptions.HIGH,
    SN: Consumptions.HIGH,
    SO: Consumptions.HIGH,
    SR: Consumptions.VERY_HIGH,
    SS: Consumptions.HIGH,
    SV: Consumptions.HIGH,
    SY: Consumptions.HIGH,
    SZ: Consumptions.HIGH,
    TD: Consumptions.HIGH,
    TG: Consumptions.HIGH,
    TH: Consumptions.HIGH,
    TJ: Consumptions.HIGH,
    TL: Consumptions.HIGH,
    TM: Consumptions.VERY_HIGH,
    TN: Consumptions.HIGH,
    TR: Consumptions.HIGH,
    TT: Consumptions.VERY_HIGH,
    TV: Consumptions.HIGH,
    TW: Consumptions.HIGH,
    TZ: Consumptions.HIGH,
    UA: Consumptions.HIGH,
    UG: Consumptions.HIGH,
    US: Consumptions.VERY_HIGH,
    UY: Consumptions.HIGH,
    UZ: Consumptions.HIGH,
    VC: Consumptions.HIGH,
    VE: Consumptions.HIGH,
    VG: Consumptions.HIGH,
    VI: Consumptions.HIGH,
    VN: Consumptions.HIGH,
    VU: Consumptions.HIGH,
    XK: Consumptions.HIGH,
    YE: Consumptions.HIGH,
    YT: Consumptions.HIGH,
    ZA: Consumptions.HIGH,
    ZM: Consumptions.HIGH,
    ZW: Consumptions.HIGH,
};
exports.veryHighImpactCountries = Object.keys(exports.locationConsumptions).filter((c) => {
    const countryConsumption = exports.locationConsumptions[c];
    return countryConsumption === Consumptions.VERY_HIGH;
});
exports.highFootprint = 8;
exports.veryHighFootprint = 17;
/**
 * Determine if the location can be used with the USMedium plans (personal, business, family)
 * @param {Location} location
 */
const isUSMediumLocation = (location) => {
    const usMediumSet = {
        AD: true,
        AF: true,
        AG: true,
        AL: true,
        AM: true,
        AO: true,
        AQ: true,
        AR: true,
        AW: true,
        AZ: true,
        BA: true,
        BB: true,
        BD: true,
        BF: true,
        BI: true,
        BJ: true,
        BM: true,
        BO: true,
        BQ: true,
        BR: true,
        BS: true,
        BT: true,
        BY: true,
        CD: true,
        CI: true,
        CL: true,
        CM: true,
        CN: true,
        CO: true,
        CR: true,
        CU: true,
        CV: true,
        CW: true,
        DO: true,
        DZ: true,
        EC: true,
        EG: true,
        EH: true,
        ET: true,
        FJ: true,
        FK: true,
        FM: true,
        FO: true,
        GA: true,
        GD: true,
        GE: true,
        GG: true,
        GH: true,
        GI: true,
        GM: true,
        GP: true,
        GQ: true,
        GR: true,
        GT: true,
        GU: true,
        HK: true,
        HN: true,
        HR: true,
        HT: true,
        ID: true,
        IL: true,
        IN: true,
        IQ: true,
        IR: true,
        IS: true,
        JE: true,
        JM: true,
        JO: true,
        JP: true,
        KE: true,
        KG: true,
        KH: true,
        KN: true,
        KR: true,
        KY: true,
        LA: true,
        LB: true,
        LC: true,
        LI: true,
        LK: true,
        LS: true,
        LT: true,
        LV: true,
        LY: true,
        MA: true,
        MC: true,
        MD: true,
        ME: true,
        MG: true,
        MK: true,
        ML: true,
        MM: true,
        MN: true,
        MO: true,
        MQ: true,
        MR: true,
        MT: true,
        MU: true,
        MV: true,
        MW: true,
        MX: true,
        MY: true,
        MZ: true,
        NA: true,
        NC: true,
        NE: true,
        NF: true,
        NG: true,
        NI: true,
        NP: true,
        NZ: true,
        PA: true,
        PE: true,
        PF: true,
        PG: true,
        PH: true,
        PK: true,
        PR: true,
        PS: true,
        PY: true,
        RE: true,
        RS: true,
        RU: true,
        RW: true,
        SC: true,
        SD: true,
        SG: true,
        SI: true,
        SK: true,
        SL: true,
        SM: true,
        SN: true,
        SO: true,
        SS: true,
        SV: true,
        SY: true,
        SZ: true,
        TD: true,
        TG: true,
        TH: true,
        TJ: true,
        TL: true,
        TN: true,
        TR: true,
        TV: true,
        TW: true,
        TZ: true,
        UA: true,
        UG: true,
        UY: true,
        UZ: true,
        VC: true,
        VE: true,
        VG: true,
        VI: true,
        VN: true,
        VU: true,
        XK: true,
        YE: true,
        YT: true,
        ZA: true,
        ZM: true,
        ZW: true,
    };
    return usMediumSet[location.countryCode] == true;
};
exports.isUSMediumLocation = isUSMediumLocation;
const getCurrencySymbol = (countryCode) => {
    const currencyCode = currencies_1.locationCurrencyCodeMapper[countryCode];
    return currencies_1.currencySymbols[currencyCode];
};
exports.getCurrencySymbol = getCurrencySymbol;
const getLocationPlans = (location) => {
    const countryCode = (0, country_transform_1.transformLocationIntoValidPlanCountryCode)(location);
    const currencyCode = currencies_1.locationCurrencyCodeMapper[countryCode];
    const plansForLocation = exports.plansForLocations[countryCode];
    const locationConsumption = exports.locationConsumptions[countryCode];
    const numTonnesPerPerson = locationConsumption === Consumptions.VERY_HIGH
        ? exports.veryHighFootprint
        : exports.highFootprint;
    return {
        businessAddonsForLocation: businessAddonOptions[countryCode],
        businessPlanIdForLocation: businessPlanOptions[countryCode],
        currencyCode,
        currencySymbol: currencies_1.currencySymbols[currencyCode],
        familyAddonsForLocation: familyAddonsForLocations[countryCode],
        familyPlanIdForLocation: familyPlanIdsForLocation[countryCode],
        locationName: countries_1.locationNames[countryCode],
        locationConsumption,
        numTonnesPerPerson,
        plansForLocation,
        localProjectAddon: tree_projects_1.projectLocationAddonMapper[countryCode],
    };
};
exports.getLocationPlans = getLocationPlans;
/**
 * When someone is redeeming a gift card they will be creating a new subscription against a basic / personal plan
 * Retrieve the listing of personal plan ids by country / location
 * @param {Location | null} location
 * @returns {string}
 */
const getGiftingPlanForLocation = (location) => {
    const countryCode = (0, country_transform_1.transformLocationIntoValidPlanCountryCode)(location);
    return plan_country_mappings_1.basicPlanIds[countryCode];
};
exports.getGiftingPlanForLocation = getGiftingPlanForLocation;
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["BUSINESS"] = "BUSINESS";
    SubscriptionType["FAMILY"] = "FAMILY";
    SubscriptionType["PERSONAL"] = "PERSONAL";
    SubscriptionType["BOOSTER"] = "BOOSTER";
    SubscriptionType["MEGA"] = "MEGA";
})(SubscriptionType || (SubscriptionType = {}));
/**
 * Retrieve a listing of the current plans and their addons for the specified location
 * @param {Location | null} location
 */
const getLocationSummaryCurrentPlans = (location) => {
    const countryCode = (0, country_transform_1.transformLocationIntoValidPlanCountryCode)(location);
    //  We need to get the planIds for personal (all flavours) / business / family
    const personalPlanIds = Object.keys(exports.plansForLocations[countryCode]);
    const businessPlanId = businessPlanOptions[countryCode];
    const familyPlanId = familyPlanIdsForLocation[countryCode];
    const planSummaryData = {
        personal: {
            id: personalPlanIds[0],
            type: SubscriptionType.PERSONAL,
            name: `Starter`,
            requiredAddons: (0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[0]),
            optionalAddons: (0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[0]),
            addons: [
                ...(0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[0]),
                ...(0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[0]),
            ],
        },
        booster: {
            id: personalPlanIds[1],
            name: `Essential`,
            type: SubscriptionType.PERSONAL,
            requiredAddons: (0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[1]),
            optionalAddons: (0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[1]),
            addons: [
                ...(0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[1]),
                ...(0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[1]),
            ],
        },
        mega: {
            id: personalPlanIds[2],
            name: `Ultimate`,
            type: SubscriptionType.PERSONAL,
            requiredAddons: (0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[2]),
            optionalAddons: (0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[2]),
            addons: [
                ...(0, addons_1.getRequiredAddonsForPlanId)(personalPlanIds[2]),
                ...(0, addons_1.getOptionalAddonsForPlanId)(personalPlanIds[2]),
            ],
        },
        business: {
            id: businessPlanId,
            name: `Business Plan`,
            type: SubscriptionType.BUSINESS,
            requiredAddons: (0, addons_1.getRequiredAddonsForPlanId)(businessPlanId),
            optionalAddons: (0, addons_1.getOptionalAddonsForPlanId)(businessPlanId),
            addons: [
                ...(0, addons_1.getRequiredAddonsForPlanId)(businessPlanId),
                ...(0, addons_1.getOptionalAddonsForPlanId)(businessPlanId),
            ],
        },
        family: {
            id: familyPlanId,
            type: SubscriptionType.FAMILY,
            name: `Family Plan`,
            requiredAddons: (0, addons_1.getRequiredAddonsForPlanId)(familyPlanId),
            optionalAddons: (0, addons_1.getOptionalAddonsForPlanId)(familyPlanId),
            addons: [
                ...(0, addons_1.getRequiredAddonsForPlanId)(familyPlanId),
                ...(0, addons_1.getOptionalAddonsForPlanId)(familyPlanId),
            ],
        },
    };
    //  We need to clean up some addons for Saudi Arabia and UAE
    if (countryCode === 'SA' || countryCode === 'AE') {
        //  The locations for SA and AE do not use the USReforestation project so we should remove it
        const businessAddonIndex = planSummaryData.business.addons.indexOf(tree_projects_1.USReforestationProject.id);
        planSummaryData.business.addons.splice(businessAddonIndex, 1);
        const familyAddonIndex = planSummaryData.family.addons.indexOf(tree_projects_1.USReforestationProject.id);
        planSummaryData.family.addons.splice(familyAddonIndex, 1);
    }
    return planSummaryData;
};
exports.getLocationSummaryCurrentPlans = getLocationSummaryCurrentPlans;
/**
 * Check that the planId is valid for the specified location
 * @param {string} planId
 * @param {Location | null} location
 */
const isValidPlanForLocation = (planId, location) => {
    const plansForLocation = (0, exports.getLocationSummaryCurrentPlans)(location);
    const isPersonalMatch = plansForLocation.personal.id === planId;
    const isBoosterMatch = plansForLocation.booster.id === planId;
    const isMegaMatch = plansForLocation.mega.id === planId;
    const isBusinessMatch = plansForLocation.business.id === planId;
    const isFamilyMatch = plansForLocation.family.id === planId;
    return (isPersonalMatch ||
        isBoosterMatch ||
        isMegaMatch ||
        isBusinessMatch ||
        isFamilyMatch);
};
exports.isValidPlanForLocation = isValidPlanForLocation;
//# sourceMappingURL=data:application/json;base64,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